import useInlinePageRouter from 'components/__new/general/useInlinePageRouter';

const BillPaymentsInlineRouter = () => {
    const { InlineRouterTab } = useInlinePageRouter();
    
    return (
        <div>
            <div className="w-full lg:w-1/2 mb-5">
                <div className="page-title flex">
                    Bill Payments
                </div>
            </div>
            
            <div className="flex items-center">
                <InlineRouterTab
                    items={[
                        {
                            title: "Airtime",
                            path: "/payments/bills/airtime"
                        },
                        {
                            title: "Data",
                            path: "/payments/bills/data"
                        },
                        {
                            title: "Electricity",
                            path: "/payments/bills/electricity"
                        },
                        {
                            title: "Cable TV",
                            path: "/payments/bills/cable-tv"
                        },
                    ]}
                />
            </div>
        </div>
    )
}

export default BillPaymentsInlineRouter